export class Investidor {
  nome: string;
  email: string;
  senha: string;
  codigoDdi: string;
  celular: string;
  telefone: string;
  rg: string;
  incapaz: boolean;
  nomeResponsavel: string;
  documentoResponsavel: string;
  documentoIdentificador: string;
  dataNascimento: string;
  termoAceite: boolean;
  usaAd: boolean;
  usuarioAtivo: boolean;
  tipoUsuario: string;
  associadoRegimeEspecialCurso: string;
  perfis: [];
  endereco?: Endereco;
}

export class Endereco {
  cep: string;
  bairro: string;
  endereco: string;
  complemento: string;
  UF: string;
  pais: string;
  cidade: string;
}
